"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMomentLocale = setMomentLocale;
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/no-internal-modules */
function setMomentLocale(lang) {
    switch (lang) {
        case 'de':
            return require('moment/locale/de');
        case 'es':
            return require('moment/locale/es');
        case 'fr':
            return require('moment/locale/fr');
        case 'it':
            return require('moment/locale/it');
        case 'nl':
            return require('moment/locale/nl');
        case 'hu':
            return require('moment/locale/hu');
        default:
        case 'en':
            return require('moment/locale/en-gb');
    }
}
